var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"info","indeterminate":""}}),_c('h3',[_vm._v("Your data is stored")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }